const workoutPageTranslations = {
  intro: {
    title: "تحدَّ حدودك \n وحقق أقصى قوتك.",
    description: "استكشف برنامج التمارين المصمم خصيصًا ليتناسب مع أهدافك.",
  },
  steps: {
    warmUp: "الإحماء",
    exercises: "التمارين",
    staticStretches: "تمدد ثابت",
  },
};

export default workoutPageTranslations;
